import { Component } from '@theme/component';

/**
 * Toggles the group-size / occasion fields on the Talleres list form
 * when the "Just you, or a group?" select changes to "A group".
 *
 * @typedef {object} Refs
 * @property {HTMLSelectElement} partySelect – The party-size select.
 * @property {HTMLElement} groupFields – The conditional group-fields wrapper.
 *
 * @extends Component<Refs>
 */
export class TalleresListFormComponent extends Component {
  requiredRefs = ['partySelect', 'groupFields'];

  connectedCallback() {
    super.connectedCallback();
    this.#syncGroupFields();
  }

  toggleGroupFields() {
    this.#syncGroupFields();
  }

  #syncGroupFields() {
    const isGroup = this.refs.partySelect.value === 'A group';
    this.refs.groupFields.hidden = !isGroup;
  }
}

if (!customElements.get('talleres-list-form-component')) {
  customElements.define('talleres-list-form-component', TalleresListFormComponent);
}
